import PropTypes from 'prop-types';
import React from 'react';

import { ReactComponent as Arrow } from '../../images/icons/fs-lc-arrow.svg';
import * as styles from './Pager.module.css';

const Pager = ({ baseUrl, currentPage, next, previous, pageDisplay = [], className = '' }) => {
  let disabledPages = [];
  if (pageDisplay.length < 3) {
    let i = 1;
    do {
      disabledPages.push(pageDisplay[pageDisplay.length - 1] + i);
      i++;
    } while (disabledPages.length + pageDisplay.length < 3);
  }
  const onNext = (e) => {
    e.preventDefault();
    if (typeof window === 'undefined') return;
    if (next) {
      window.location = `${baseUrl ? baseUrl : '/resources'}/${next[0]}`;
    }
  };

  const onPrev = (e) => {
    e.preventDefault();
    if (typeof window === 'undefined') return;
    if (previous) {
      let num = previous[0] === 1 ? '' : previous[0];
      window.location = `${baseUrl ? baseUrl : '/resources'}/${num}`;
    }
  };

  return (
    <div className={[styles.wrap, className].join(' ')}>
      <button onClick={onPrev} className={[styles.button, previous ? '' : styles.disabled].join(' ')}>
        <Arrow className={styles.leftArrow} /> Previous
      </button>
      {pageDisplay.map((num, i) => {
        return (
          <button
            onClick={() => {
              if (typeof window === 'undefined') return;
              if (num === 1) {
                return (window.location = baseUrl || `/resources/`);
              }
              window.location = `${baseUrl || '/resources'}/${num}`;
            }}
            className={[styles.button, currentPage === num ? styles.current : ''].join(' ')}
            key={i}
          >
            {num}
          </button>
        );
      })}
      {disabledPages &&
        disabledPages.map((pageNum) => (
          <button className={[styles.button, styles.disabled].join(' ')} key={pageNum}>
            {pageNum}
          </button>
        ))}
      <button onClick={onNext} className={[styles.button, next ? '' : styles.disabled].join(' ')}>
        Next <Arrow />
      </button>
    </div>
  );
};

Pager.propTypes = {
  baseUrl: PropTypes.string,
  currentPage: PropTypes.number,
  next: PropTypes.array,
  previous: PropTypes.array,
  pageDisplay: PropTypes.array,
};

export default Pager;
